import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { GeneralErrorMessage } from './components/GeneralErrorMessage';
import { SavedPaymentMethods } from './components/SavedPaymentMethods';
import { StripeCreditCard } from './components/StripeCreditCard';
import { StripeSepa } from './components/StripeSepa';
import { usePaymentMethods } from './hooks/usePaymentMethods';

export const PaymentMethods: React.FC = () => {
	const {
		data: { inlinePaymentMethods, expandedMethod, collapsible, displayExperiment },
		actions: { toggleExpanded, setDisplayExperiment },
	} = usePaymentMethods();

	return (
		<div className="flex flex-col gap-5 md:gap-7">
			<Text variant="body" size="large" fontWeight="bold">
				<Translate value="fe.components.credit_card.payment_method" />
			</Text>
			<GeneralErrorMessage />
			{displayExperiment && <SavedPaymentMethods setDisplayExperiment={setDisplayExperiment} />}
			{!displayExperiment && (
				<div className="flex flex-col gap-3 md:gap-4">
					{inlinePaymentMethods.length > 0 && (
						<div className="flex flex-col gap-3 md:flex-row md:gap-4">
							{inlinePaymentMethods.map(({ type, component: Component }) => {
								return <Component key={type} />;
							})}
						</div>
					)}
					<StripeCreditCard
						collapsible={collapsible}
						expandedPaymentMethod={expandedMethod}
						onToggle={toggleExpanded}
					/>
					<StripeSepa collapsible={collapsible} expandedPaymentMethod={expandedMethod} onToggle={toggleExpanded} />
				</div>
			)}
		</div>
	);
};
